import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import "./style.scss";

ChartJS.register(ArcElement, Tooltip, Legend);

interface DoughnutProps {
  totalIncome?: number;
  totalOutcome?: number;
}

export const DoughnutComponent = ({
  totalIncome = 0,
  totalOutcome = 0,
}: DoughnutProps) => {
  const data = {
    datasets: [
      {
        data: [totalIncome, totalOutcome],
        backgroundColor: ["rgb(0,128,0)", "rgb(255,182,193)"],
        borderWidth: 0,
      },
    ],
  };

  return <Doughnut data-testid="doughnut" data={data} />;
};
